import api from "@/services/api"
import type { CardTransactionData } from "@/androidPlugins/IPayment"

import type { RecursivelyConvertDatesToStrings } from "@/utils/typeUtilities"
import type { CreateRefundResponse } from "../createRefund"

export const createUnlinkedRefund = async (input: {
  source: "pos_card"
  data: CardTransactionData
}): Promise<CreateRefundResponse> => {
  const { body } = await api.post<
    RecursivelyConvertDatesToStrings<CreateRefundResponse>
  >("/transactions/unlinked-refunds/", {
    body: input,
  })

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
  }
}
